<template>

  <app-layout>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/report.svg" class="h-8 w-8"/>
        <span class="ml-2"> Stand Up - Slack</span>
      </h2>
    </template>

    <div class="h-full flex">
      <div class="flex flex-col w-0 flex-1">
        <main class="flex-1 relative focus:outline-none px-8">
          <bread-nav :pages="pages"></bread-nav>
          <div v-if="!is_sign_in || !is_installed">
            <div class="flex justify-center">
              <img height="100" width="100" src="/images/logo.png"
                   class="shadow-lg w-45 h-45 mb-5  bg-white rounded-full "/>
            </div>

            <div class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
              <svg class="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
                   width="404"
                   height="784" fill="none" viewBox="0 0 404 784" aria-hidden="true">
                <defs>
                  <pattern id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7" x="0" y="0" width="20" height="20"
                           patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor"/>
                  </pattern>
                </defs>
                <rect width="404" height="784" fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"/>
              </svg>

              <div class="relative">
                <h2 class="text-center mb-4 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  A better way to create scheduled reports for Slack.
                </h2>
              </div>

              <div class="py-5 mx-auto max-w-md">
                <add-to-slack-button></add-to-slack-button>
                <span
                    class=" text-md text-black font-bold">If your app hasn't been installed, please add AgileBot to your Slack workspace.</span>
              </div>

              <!--                <div class="flex mt-2 justify-center">-->
              <!--          <span-->
              <!--              class=" text-md text-black font-bold">Free for now (For further pricing changes, we will notify you.)</span>-->
              <!--                </div>-->


              <div class="py-5 mx-auto max-w-md">
                <sign-in-with-slack label="Connect Your Slack Account"></sign-in-with-slack>
                <span
                    class=" text-md text-black font-bold">If the app has already been installed, please connect your Slack account.</span>
              </div>

              <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 font-bold text-lg mt-5">
                <div class="flex w-full text-red-400 justify-center">
                  <div class="py-1">
                    <svg class="fill-current h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 20 20">
                      <path
                          d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
                    </svg>
                  </div>
                  This feature is part of Agile Bot and only supports Slack team.

                </div>
              </div>

            </div>
          </div>

          <div v-else>

            <div class="space-y-5 mt-5">
              <div class="bg-white shadow sm:rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Reinstall App
                  </h3>
                  <div class="mt-2 sm:flex sm:items-start sm:justify-between">
                    <div class="max-w-xl text-sm text-gray-500">
                      <p>
                        Use this option if you encounter any weird problems to see if its fixed.
                      </p>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                      <button @click="reinstall()"
                              type="button"
                              class="inline-flex font-bold items-center px-4 py-2 border border-transparent shadow-sm  rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
                        Reinstall
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              <div class="bg-white shadow sm:rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Switch Slack Team
                  </h3>
                  <div class="mt-2 sm:flex sm:items-start sm:justify-between">
                    <div class="max-w-xl text-sm text-gray-500">
                      <p>
                        You are currently connected with <label class="text-blue-400">{{
                          slack_user.slack_email
                        }} </label> on
                        <label class="text-blue-400"> {{ slack_user.slack_team_name }} </label> Slack workspace. Click
                        button to connect with other Slack account.
                      </p>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                      <button @click="switchTeam()"
                              type="button"
                              class="inline-flex font-bold items-center px-4 py-2 border border-transparent shadow-sm  rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
                        Switch Slack Team
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-white shadow sm:rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Install it to another Slack Workspace
                  </h3>
                  <div class="mt-2 sm:flex sm:items-start sm:justify-between">
                    <div class="max-w-xl text-sm text-gray-500">
                      <p>
                        You can use this button to install the AgileBot to other Slack Workspace.
                      </p>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                      <button @click="installToOther()"
                              type="button"
                              class="inline-flex font-bold items-center px-4 py-2 border border-transparent shadow-sm  rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
                        Add it to other Slack Workspace
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-white shadow sm:rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Uninstall
                  </h3>
                  <div class="mt-2 sm:flex sm:items-start sm:justify-between">
                    <div class="max-w-xl text-sm text-gray-500">
                      <p>
                        Go to slack official directory page and uninstall from there.
                      </p>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                      <button @click="goToSlackDelete()"
                              type="button"
                              class="inline-flex font-bold items-center px-4 py-2 border border-transparent shadow-sm rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm">
                        Uninstall
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </main>
      </div>
    </div>


  </app-layout>

</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import BreadNav from "@/Components/BreadNav/BreadNav";
import AddToSlackButton from "@/Components/SocialButton/AddToSlackButton";
import SignInWithSlack from "@/Components/SocialButton/SignInWithSlackButton";

const pages = [
  {name: 'Report', href: '#', current: false},
  {name: 'Slack Setting', href: '#', current: true},
]
export default {
  props: [
    "slack_user", 'is_installed', 'is_sign_in'
  ],
  components: {
    BreadNav,
    AppLayout,
    AddToSlackButton,
    SignInWithSlack
  },
  methods: {
    goToSlackDelete() {
      window.open('https://agile-suite.slack.com/apps/AT22KJ4SE-agile-bot', '_blank');
    },
    switchTeam() {
      window.location.href = window.location.origin + '/slack/install-app/sign-in';
    },
    installToOther() {
      window.location.href = window.location.origin + '/slack/install-app/agile-bot';
    },
    reinstall() {
      window.location.href = '/slack/install-app/agile-bot';
    }
  },
  mounted() {

  },
  created() {

  },
  setup() {

    return {
      pages
    }
  },
  data() {
    return {}
  }
}
</script>
